/**
 * analyticsButtonClickKey – ключ для аналитики
 * expirationDateTime — дата, до которой будет показываться баннер в формате ISO (YYYY-MM-DDTHH:MM:SS.SSSZ)
 * showButtonLink — нужно ли показывать CTA-кнопку
 * localStorageDisableOnClickKey — ключ для LocalStorage, чтобы после клика больше не показывать баннер. Если не указан, то баннер будет показываться даже после клика
 * showPeriodInDays — частота показа баннера после закрытия в днях. Если не указан, то баннер будет показываться каждый раз
 * localStorageLastDateKey — ключ для LocalStorage, чтобы хранить дату последнего показа баннера. Если не указан, то баннер будет показываться каждый раз
 */
export interface WebinarBannerConfig {
    titleTrlKey: string;
    descriptionTrlKey: string;
    buttonLinkTrlKey?: string;
    analyticsButtonClickKey: string;
    expirationDateTime: Date;
    localStorageDisableOnClickKey?: string;
    showPeriodInDays?: number;
    localStorageLastDateKey?: string;
}

export const WEBINAR_BANNER_CONFIG: WebinarBannerConfig = {
    titleTrlKey: 'Dashboard.WebinarBanner.title',
    descriptionTrlKey: 'Dashboard.WebinarBanner.description',
    buttonLinkTrlKey: 'Dashboard.WebinarBanner.buttonLink',
    analyticsButtonClickKey: 'dashboard_webinar_banner_19_06_2026',
    expirationDateTime: new Date('2026-06-19T08:00:00.000Z'),
    localStorageDisableOnClickKey: 'WEBINAR_19_06_2026_DISABLED',
    localStorageLastDateKey: 'WEBINAR_19_06_2026_LAST_DATE',
    showPeriodInDays: 3,
};
